import { NavBottomPadding } from '@styles/base.style'
import styled from '@themes/theme'
import { keyframes } from '@emotion/core'

export const StarAni = keyframes`
  0% {
    opacity: .15;
  }
  100%  {
    opacity: 1;
  }
`
export const LightAni = keyframes`
  0%, 20% {
    transform: rotate(-10deg);
    opacity: 1;
  }
  50% {
    opacity: .7;
  }
  80%, 100%  {
    transform: rotate(25deg);
    opacity: 1;
  }
`
export const LightAni2 = keyframes`
  0%, 18% {
    transform: rotate(60deg);
    opacity: 1;
  }
  40% {
    opacity: .4;
  }
  78%, 100%  {
    transform: rotate(30deg);
    opacity: 1;
  }
`
export const LightAni3 = keyframes`
  0%, 15% {
    transform: rotate(-60deg);
    opacity: 1;
  }
  40% {
    opacity: .6;
  }
  85%, 100%  {
    transform: rotate(-10deg);
    opacity: 1;
  }
`
export const FireworkAni = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  5% {
    transform: scale(1);
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  45%{
    transform: scale(1.1);
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
`
export const opacityAni = keyframes`
  0%{
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const starAniTime = '1.2s'
const starAniTime2 = '.8s'

export const AdvCasinoWrap = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-bottom: ${NavBottomPadding};
  background: #050017;
  overflow: hidden;
  &:not(.pc-adv-casino-wrap) {
    margin-top: -34px;
  }
  .star-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vw;
    .star {
      position: absolute;
      width: 2px;
      height: 2px;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0 0 4px #fff;
      animation: ${StarAni} infinite alternate-reverse ease-in-out;
      &-01 {
        top: 6%;
        left: 41%;
        transform: scale(.7);
        animation-duration: ${starAniTime};
      }
      &-02 {
        top: 42%;
        left: 12%;
        transform: scale(.65);
        animation-delay: .1s;
        animation-duration: ${starAniTime};
      }
      &-03 {
        top: 7%;
        left: 73%;
        transform: scale(.8);
        animation-delay: .15s;
        animation-duration: ${starAniTime2};
      }
      &-04 {
        top: 21%;
        left: 61%;
        transform: scale(.9);
        animation-delay: .2s;
        animation-duration: ${starAniTime};
      }
      &-05 {
        bottom: 45%;
        left: 77%;
        transform: scale(.5);
        animation-delay: .25s;
        animation-duration: ${starAniTime2};
      }
      &-06 {
        top: 37%;
        left: 24%;
        transform: scale(.5);
        animation-delay: .3s;
        animation-duration: ${starAniTime};
      }
      &-07 {
        top: 6%;
        left: 49%;
        transform: scale(.45);
        animation-delay: .35s;
        animation-duration: ${starAniTime};
      }
      &-08 {
        top: 17%;
        left: 56%;
        transform: scale(.45);
        animation-duration: ${starAniTime2};
      }
      &-09 {
        top: 6%;
        left: 84%;
        transform: scale(.5);
        animation-delay: .45s;
        animation-duration: ${starAniTime};
      }
      &-10 {
        top: 20%;
        left: 45%;
        transform: scale(.8);
        animation-delay: .5s;
        animation-duration: ${starAniTime};
      }
      &-11 {
        top: 11%;
        left: 61%;
        transform: scale(.5);
        animation-delay: .55s;
        animation-duration: ${starAniTime};
      }
    }
  }
  .firework-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 100vw;
    height: 100vw;
    overflow: hidden;
    .firework {
      position: absolute;
      height: auto;
      opacity: 0;
      animation: ${FireworkAni} 4s infinite cubic-bezier(.13,.53,.34,.44);
      &.firework-01 {
        top: 6%;
        left: 8%;
        width: 25%;
      }
      &.firework-02 {
        top: 11%;
        left: 73%;
        width: 40%;
        animation-delay: .6s;
      }
      &.firework-03 {
        top: 47%;
        left: 6%;
        width: 17%;
        mix-blend-mode: color-dodge;
        animation-delay: .35s;
        animation-name: ${FireworkAni};
      }
    }
  }
  .light-wrap {
    position: absolute;
    top: 121px;
    left: 0;
    width: 100%;
    height: 78vw;
    .light-img {
      position: absolute;
      width: 20%;
      height: auto;
      transform-origin: bottom;
      animation: ${LightAni} infinite alternate-reverse ease-in-out;
      &-01 {
        bottom: 0;
        left: 41%;
        animation-duration: 3.5s;
      }
      &-02 {
        bottom: 0;
        left: 49%;
        width: 17%;
        animation-name: ${LightAni2};
        animation-duration: 5s;
        animation-delay: .1s;
      }
      &-03 {
        bottom: 0;
        left: 35%;
        animation-name: ${LightAni3};
        animation-duration: 4s;
      }
    }
  }
  .casino-logo {
    position: absolute;
    top: 4%;
    left: 50%;
    transform: translateX(-50%);
    width: 44vw;
    height: auto;
    image-rendering: -webkit-optimize-contrast;
    opacity: 0;
    animation: ${opacityAni} .4s forwards 1 cubic-bezier(.14,.02,1,-0.05);
    animation-delay: .5s;
  }
  .casino-video {
    margin-top: -25vw;
    width: calc(100% - 36px);
    height: calc(100vw - 180px);
    // 영상 로딩 중 흰화면이 보이는 현상 해결
    opacity: 0;
    animation: ${opacityAni} .05s forwards 1 cubic-bezier(.14,.02,1,-0.05);
    animation-delay: .2s;
  }
  .casino-guide-btn {
    left: 50%;
    width: 112px;
    height: auto;
    transform: translateX(-50%);
  }
  // PC 버전
  &.pc-adv-casino-wrap {
    .star-wrap {
      height: 580px;
    }
    .firework-wrap {
      height: 600px;
      .firework {
        &.firework-01 {
          top: 3%;
          left: 10%;
          width: 153px;
        }
        &.firework-02 {
          top: 6%;
          left: 73%;
          width: 227px;
        }
        &.firework-03 {
          top: 42%;
          left: 6%;
          width: 105px;
        }
      }
    }
    .light-wrap {
      top: 210px;
      height: 410px;
      .light-img {
        width: 20%;
        &.light-02 {
          width: 16%;
        }
      }
    }
    .casino-logo {
      top: 170px;
      width: 250px;
    }
    .casino-video {
      margin-top: -120px;
      width: 480px;
      height: 270px;
    }
    .casino-guide-btn {
      width: 150px;
      transform: translateX(-70%);
    }
    .carousel-wrap {
      position: relative;
      width: 100%;
      margin-top: 14px;
      .swiper-pointer-events {
        padding: 0 90px;
      }
      .swiper-thumbs {
        margin-top: 42px;
        padding: 42px 60px;
        background: #17122a;
        .swiper-slide {
          opacity: .5;
          transition: all .15s;
          cursor: pointer;
          &:not(.swiper-slide-thumb-active):hover {
            opacity: .8;
          }
        }
        .swiper-slide-thumb-active {
          opacity: 1;
          cursor: auto;
        }
      }
      .swiper-button-prev, .swiper-button-next {
        width: 40px;
        height: 40px;
        margin-top: -20px;
        &::before, &::after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 1px;
          height: 50%;
          background: ${props => props.theme.color.themeTxt};
        }
        &::before {
          transform: translate(-50%, -90%) rotate(45deg);
        }
        &::after {
          transform: translate(-50%, -20%) rotate(-45deg);
        }
      }
      .swiper-button-prev {
        left: 40px;
      }
      .swiper-button-next {
        transform: rotate(180deg);
        right: 40px;
      }
    }
  }
  .dia-event-btn {
    margin-top: 20px;
    &.pc-btn {
      margin-top: 40px;
    }
  }
`
